const headerLeftContainerStyle = {
  padding: 0,
  margin: 0,
};

const headerTitleContainerStyle = {
  left: 0,
  right: 94,
};

const headerBackTitleStyle = {
  margin: 0,
  padding: 0,
  textAlign: 'left',
};

export {
  headerLeftContainerStyle,
  headerTitleContainerStyle,
  headerBackTitleStyle,
};
